import {PRODUCTION} from './production'
import {TESTING} from './testing'

export const YANDEXCOM = {
  testing: TESTING,
  production: PRODUCTION,
}
